"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
exports.IconButton = (0, react_1.forwardRef)(({ children, unpadded, rounded, sx = [], ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)(material_1.IconButton, { ref: ref, ...props, sx: [
            {
                padding: unpadded ? "4px" : "8px",
                borderRadius: "4px",
                ...(rounded && {
                    borderRadius: "50%",
                    "&:focus-visible:after": {
                        borderRadius: "50%",
                    },
                }),
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: children }));
});
